import {
    getOWAConnectedAccounts,
    isConnectedAccount,
    isMonarchMultipleAccountsEnabled,
} from 'owa-accounts-store';
import { isConsumer } from 'owa-session-store';
import { isWorkViewEnabled, isLifeViewEnabled } from './readWorkLifeViewOption';

export function isAutoSelectEnabledForUser(userIdentity: string): boolean {
    if (isMonarchMultipleAccountsEnabled()) {
        return isMonarchAutoSelectEnabledForUser(userIdentity);
    } else {
        return isWorkLifeViewEnabledForUser(userIdentity);
    }
}

function isWorkLifeViewEnabledForUser(userIdentity: string): boolean {
    if (isConsumer() || getOWAConnectedAccounts().length == 0) {
        // always return true if this a consumer scenario or if this enterprise scenario with no connected accounts
        return true;
    } else {
        return (
            ((!isConnectedAccount(userIdentity) && isWorkViewEnabled()) ||
                (isConnectedAccount(userIdentity) && isLifeViewEnabled())) > 0
        );
    }
}

function isMonarchAutoSelectEnabledForUser(userIdentity: string): boolean {
    if (isConsumer() || getOWAConnectedAccounts().length == 1) {
        // always return true if this a consumer scenario or if this enterprise scenario with no connected accounts
        return true;
    } else {
        // In Monarch multi-account we may have an arbitrary mixture of work/life accounts.
        // Since there isn't a binary division of accounts, Work/Life view toggle doesn't apply.
        // TODO: VSO# 130595
        return false;
    }
}
